import styled from 'styled-components'

const StyledHeaderBtns = styled.div`
display: none;

@media (min-width: 800px){
    display: flex;
}
`

export default StyledHeaderBtns;